import { render, staticRenderFns } from "./ApplicationRegistration.vue?vue&type=template&id=2185b1b2&scoped=true"
import script from "./ApplicationRegistration.vue?vue&type=script&lang=ts"
export * from "./ApplicationRegistration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2185b1b2",
  null
  
)

export default component.exports